import React from 'react'
import styled from 'styled-components'

type Props = {
  label: string
  value: string
  placeholder?: string
  type?: string
  error?: string
  onChange: (value: string) => void
  onBlur?: () => void
}

const SimpleInputField = ({
  label,
  value,
  onChange,
  onBlur,
  placeholder,
  error,
  type = 'text',
}: Props) => {
  return (
    <FieldWrapper>
      <label>{label}</label>
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        className={error ? 'error' : ''}
      />
      {error && <span className="error-text">{error}</span>}
    </FieldWrapper>
  )
}

export default SimpleInputField

const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  label {
    font-weight: 800;
    font-size: 16px;
  }

  input {
    border: 1px solid #c6b98c;
    border-radius: 10px;
    padding: 10px 14px;
    background-color: white;
    font-size: 16px;
  }

  input::placeholder {
    font-size: 16px;
  }

  input.error {
    border-color: #ff4d4f;
  }

  .error-text {
    font-size: 14px;
    color: #ff4d4f;
    line-height: 18px;
    white-space: break-spaces;
    padding: 0;
    margin: 0;
  }
`
